import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/system";
import RascoinSvg from "../../../public/main/R.svg";
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';

// Styled container for the coin
const CoinContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "60vh",
    maxHeight: '400px',
    backgroundColor: theme.palette.background.default,
}));

// Styled coin shape
const CoinShape = styled(Box)(({ theme }) => ({
    width: "220px",
    height: "220px",
    borderRadius: "50%",
    background: `radial-gradient(circle at 30% 30%, #f7f7f7, #e0e0e0, #c0c0c0)`, // Softer, more elegant gradient
    border: "10px solid #d1cfcf", // Light gray border
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1), inset 0px 6px 8px rgba(255, 255, 255, 0.5)", // Softer shadow
    position: "relative",
}));

// Embossed text around the coin
const EmbossedText = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "10px",
    width: "100%",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#3e2f14",
    textShadow: "1px 1px 0px #fff, -1px -1px 0px #3e2f14",
    pointerEvents: "none",
}));

// SVG Logo component
const RascoinLogo = () => (
    <img
        src={RascoinSvg}
        alt="Rascoin Logo"
        style={{ width: "90px", height: "90px" }}
    />
);

const CoinComponent = () => {
    const { t, i18n } = useTranslation();

    return (
        <CoinContainer>

            <CoinShape>
                <EmbossedText />
                <motion.div
                    initial={{
                        scale: 0,
                        rotateY: 0,
                        z: 0
                    }}
                    whileInView={{
                        scale: [0, 4, 4, 1], // Scales up, pauses, then settles
                        rotateY: [0, 360, 720, 1080], // Spins 3 full times
                        z: [0, 3, 3, 0] // Moves forward, pauses, then comes back
                    }}
                    transition={{
                        duration: 2.5, // Overall animation duration
                        times: [0, 0.4, 0.7, 1], // Controls when keyframes occur
                        ease: "easeInOut"
                    }}
                // viewport={{ once: true }}
                >
                    <RascoinLogo />
                </motion.div>
            </CoinShape>


            <Typography
                sx={{ marginTop: 3, color: "#8c6e15", textAlign: "center", fontWeight: "bold", backgroundColor: "radial-gradient(circle at 30% 30%, #f7f7f7, #e0e0e0, #c0c0c0)" }}
            >
                {i18n.language === "en" ? " Rascoin : Trust Layer Empowering Agreements & Smart Transactions" : "Rascoin : Couche de Confiance pour des Accords Sécurisés et des Transactions Intelligentes"}
            </Typography>
            <Typography
                sx={{ color: '#9C27B0', textAlign: "center", fontWeight: "bold", backgroundColor: "radial-gradient(circle at 30% 30%, #f7f7f7, #e0e0e0, #c0c0c0)" }}
            >
                {i18n.language === "en" ? "Designed to Evolve: A Cryptocurrency That Adapts to an Ever-Changing World." : "Conçue pour évoluer—Une cryptomonnaie qui s’adapte à un monde en perpétuel changement."}
            </Typography>
            <Button href={`${i18n.language}/rascoin`}>{i18n.language === "en" ? "Learn More..." : "En savoir plus..."}</Button>
        </CoinContainer>
    );
};

export default CoinComponent;
